import "core-js/modules/es.function.name.js";
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  token: function token(state) {
    return state.user.token;
  },
  type: function type(state) {
    return state.user.type;
  },
  userid: function userid(state) {
    return state.user.userid;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  plan_id: function plan_id(state) {
    return state.user.plan_id;
  },
  form_id: function form_id(state) {
    return state.user.form_id;
  },
  institution_id: function institution_id(state) {
    return state.user.institution_id;
  },
  institution: function institution(state) {
    return state.user.institution;
  },
  username: function username(state) {
    return state.user.username;
  },
  nickname: function nickname(state) {
    return state.user.nickname;
  },
  mobile: function mobile(state) {
    return state.user.mobile;
  },
  department: function department(state) {
    return state.user.department;
  },
  department_id: function department_id(state) {
    return state.user.department_id;
  },
  name: function name(state) {
    return state.user.name;
  },
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  show_logo: function show_logo(state) {
    return state.user.show_logo;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  errorLogs: function errorLogs(state) {
    return state.errorLog.logs;
  },
  qiniuToken: function qiniuToken(state) {
    return state.qiniu.Token;
  },
  admin_menu_paths: function admin_menu_paths(state) {
    return state.user.admin_menu_paths;
  },
  admin_role_ids: function admin_role_ids(state) {
    return state.user.admin_role_ids;
  },
  modal: function modal(state) {
    return state.user.modal;
  },
  buyer_id: function buyer_id(state) {
    return state.user.buyer_id;
  }
};
export default getters;